import { createFileRoute } from '@tanstack/react-router'
import { ClientListFeature } from '@/features/client-list/ClientListFeature'

export const Route = createFileRoute('/clients/')({
  component: ClientsPage,
  staticData: { authorize: true },

})

function ClientsPage() {
  return <ClientListFeature />
}
